module.exports = __webpack_public_path__ + "img/myposition_dm.c5aebed2.svg";